import { JsonObject, JsonProperty} from 'json2typescript';
import { DOCUMENT_CATEGORIES } from '../const/app';

@JsonObject('DocumentModel')
export default class DocumentModel {
  @JsonProperty('id', Number) public id:number = undefined;
  @JsonProperty('name', String) public name:string = undefined;
  @JsonProperty('category', String, true) public category:DOCUMENT_CATEGORIES = undefined;
}
